import React from 'react';
import {Link} from "react-router-dom";

export default class extends React.Component{
    contextTypes: {
        router: React.PropTypes.object
    }

    render() {
      //  let isActive = this.context.router.isActive(this.props.to, true),
        //    className = isActive ? "active" : "";
//        className = this.props.to == this.props.default ? "active" : "";
        var className = '';
        return (
            <li className={className}>
                <Link {...this.props}>
                    {this.props.children}
                </Link>
            </li>
        );
    }
}